/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Engagement_Today_MilestoneInputs */

const en_us2_engagement_today_milestone = /** @type {(inputs: Engagement_Today_MilestoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You've reached ${i?.count} workouts. Every one of them counted.`)
};

const pt_br2_engagement_today_milestone = /** @type {(inputs: Engagement_Today_MilestoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você chegou a ${i?.count} treinos. Cada um deles contou.`)
};

const es_419_engagement_today_milestone = /** @type {(inputs: Engagement_Today_MilestoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Llegaste a ${i?.count} entrenamientos. Cada uno de ellos contó.`)
};

const pt_pt2_engagement_today_milestone = /** @type {(inputs: Engagement_Today_MilestoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chegaste aos ${i?.count} treinos. Cada um deles contou.`)
};

const fr_fr2_engagement_today_milestone = /** @type {(inputs: Engagement_Today_MilestoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu as atteint ${i?.count} séances. Chacune d'elles a compté.`)
};

const de_de2_engagement_today_milestone = /** @type {(inputs: Engagement_Today_MilestoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du hast ${i?.count} Trainings erreicht. Jedes einzelne hat gezählt.`)
};

const it_it2_engagement_today_milestone = /** @type {(inputs: Engagement_Today_MilestoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sei arrivato a ${i?.count} allenamenti. Ognuno di loro è contato.`)
};

/**
* | output |
* | --- |
* | "You've reached {count} workouts. Every one of them counted." |
*
* @param {Engagement_Today_MilestoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_today_milestone = /** @type {((inputs: Engagement_Today_MilestoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Today_MilestoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_today_milestone(inputs)
	if (locale === "es-419") return es_419_engagement_today_milestone(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_today_milestone(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_today_milestone(inputs)
	if (locale === "de-DE") return de_de2_engagement_today_milestone(inputs)
	if (locale === "it-IT") return it_it2_engagement_today_milestone(inputs)
	return en_us2_engagement_today_milestone(inputs)
});
export { engagement_today_milestone as "engagement.today_milestone" }